import script from "./dataTable.vue?vue&type=script&setup=true&lang=js"
export * from "./dataTable.vue?vue&type=script&setup=true&lang=js"

import "./dataTable.vue?vue&type=style&index=0&id=404c8da6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-404c8da6"]])

export default __exports__